import { Component } from '@angular/core';

@Component({
  selector: 'default-module',
  templateUrl: './module.component.html',
  styleUrls: []
})
export class ModuleComponent {
}
